export enum RegistrationControlItem {
  InvestorData = 'InvestorData',
  Address = 'Address',
  Representatives = 'Representatives',
  EconomicGroup = 'EconomicGroup',
  Profession = 'Profession',
  BankData = 'BankData',
  ContractData = 'ContractData',
  BeneficiariesData = 'BeneficiariesData',
  AuthorizationsDeclarations = 'AuthorizationsDeclarations',
  SuitabilityProduct = 'SuitabilityProduct',
  SuitabilitySituation = 'SuitabilitySituation',
  SuitabilityKnowledge = 'SuitabilityKnowledge',
  Suitability = 'Suitability',
  Confirmations = 'Confirmations',
  InvestorRepresentative = 'InvestorRepresentative',
  Partner = 'Partner',
  FiscalData = 'FiscalData',
  ProductPortfolio = 'ProductPortfolio',
  FinancialInformation = 'FinancialInformation',
  Patrimonial = 'Patrimonial',
  PaymentAccountOpening = 'PaymentAccountOpening'
}
